/**
 * Dashboard Stats Tiles Component
 * Displays the summary statistics cards at the top of the dashboard
 */
import { Card } from "@/components/ui/card";
import { ShieldCheck, ShieldAlert, ShieldPlus, AlertTriangle, FileText } from "lucide-react";

const DashboardStats = ({ summary }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-4 flex-shrink-0">
      <Card className="p-3" data-testid="stat-total">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-secondary rounded flex items-center justify-center flex-shrink-0">
            <FileText className="w-4 h-4 text-primary" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Total Rules</p>
            <p className="text-xl font-bold font-['Manrope']">{summary.total}</p>
          </div>
        </div>
      </Card>

      <Card className="p-3 border-l-2 border-l-red-700" data-testid="stat-critical">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-red-100 dark:bg-red-950/50 rounded flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-4 h-4 text-red-700" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Critical Non-Compliant</p>
            <p className="text-xl font-bold font-['Manrope'] text-red-700">{summary.critical_count || 0}</p>
          </div>
        </div>
      </Card>

      <Card className="p-3 border-l-2 border-l-orange-500" data-testid="stat-non-compliant">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-orange-50 dark:bg-orange-950/30 rounded flex items-center justify-center flex-shrink-0">
            <ShieldAlert className="w-4 h-4 text-orange-600" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Non-Critical Non-Compliant</p>
            <p className="text-xl font-bold font-['Manrope'] text-orange-600">{summary.non_compliant - (summary.critical_count || 0)}</p>
          </div>
        </div>
      </Card>

      <Card className="p-3 border-l-2 border-l-amber-500" data-testid="stat-over-compliant">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-amber-50 dark:bg-amber-950/30 rounded flex items-center justify-center flex-shrink-0">
            <ShieldPlus className="w-4 h-4 text-amber-600" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Over-Compliant</p>
            <p className="text-xl font-bold font-['Manrope'] text-amber-600">{summary.over_compliant}</p>
          </div>
        </div>
      </Card>

      <Card className="p-3 border-l-2 border-l-emerald-500" data-testid="stat-compliant">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-emerald-50 dark:bg-emerald-950/30 rounded flex items-center justify-center flex-shrink-0">
            <ShieldCheck className="w-4 h-4 text-emerald-600" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Compliant</p>
            <p className="text-xl font-bold font-['Manrope'] text-emerald-600">{summary.compliant}</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default DashboardStats;
